// extracted by mini-css-extract-plugin
module.exports = {"trust":"styles_trust__233F3","avatars":"styles_avatars__N_Fyn","av1":"styles_av1__NLshs","av2":"styles_av2__8t8df","av3":"styles_av3__Kpe8F","trustText":"styles_trustText__t1BJo"};